
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPartlycloudyDayColour as ObiPartlycloudyDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-partlycloudy-day-colour.js';
 
 
 

 
 export const ObiPartlycloudyDayColour = createComponent({
   react: React,
   tagName: 'obi-partlycloudy-day-colour',
   elementClass: ObiPartlycloudyDayColourElement,
   events: {
     
   }
  });
 
 